import { render, staticRenderFns } from "./UpdateAttachmentNameModal.vue?vue&type=template&id=9e003650&"
import script from "./UpdateAttachmentNameModal.vue?vue&type=script&lang=js&"
export * from "./UpdateAttachmentNameModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAttachmentNameModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports